"use client";

import { Heading } from "@pamperedchef/design-system";
import { RichText } from "@/composites/foundation";
import type { UseAndCareGuide } from "../AboutTheProduct";
import * as styles from "./UseAndCareGuideView.module.scss";

export interface UseAndCareGuideViewProps {
	guide: UseAndCareGuide;
	className?: string;
}

/**
 * Standalone Use & Care guide page body — the heading + RTE content shown on
 * the dedicated `/shop/useandcare/{product}/{sku}` route between the global
 * Header and Footer, so the guide can be opened in a new tab.
 */
export function UseAndCareGuideView({
	guide,
	className
}: UseAndCareGuideViewProps): JSX.Element {
	return (
		<section
			className={[styles["guide"], className ?? ""]
				.filter(Boolean)
				.join(" ")}
			data-component="UseAndCareGuideView"
			aria-labelledby="use-and-care-heading"
		>
			<Heading
				tag="h1"
				id="use-and-care-heading"
				className={styles["guide__heading"]}
			>
				{guide.title}
			</Heading>

			{guide.bodyHtml ? (
				<div className={styles["guide__body"]}>
					<RichText content={guide.bodyHtml} />
				</div>
			) : null}
		</section>
	);
}
